<div class="share-button" [ngClass]="{'share-button--background' : addBackground}" (click)="openShareMenu()">
  <span class="icon-share-arrow2"></span>
</div>
